import React from "react";
import { Button, Col, Form, Row } from "antd";
import {
  GUTTER_MD,
  MARGIN_MD,
  SPAN_FULL,
  MARGIN_SM,
  MODAL_WIDTH_SM,
} from "../../../../../styles/constants";
import EnhancedModal from "../../../../../components/enhanced-modal";
import { compose } from "redux";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import FileInput from "../../../../../components/file-input";
import {
  changeFileMappingWizardCalcImport,
  submitFileMappingWizardImportCalcRules,
  onHideImportCalcRules,
} from "./actions";

const mapStateToProps = (state) => ({
  importRulesForm: state.scenes.dataManager.fileMapping.components.wizard.shared.importRulesForm,
  isVisible: state.scenes.dataManager.fileMapping.components.wizard.shared.importCalcRulesShow,
  tempTableName: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
});

const mapDispatchToProps = (dispatch) => ({
  onChange: (fields) => dispatch(changeFileMappingWizardCalcImport(fields)),
  onSubmit: (file, tableName) =>
    dispatch(submitFileMappingWizardImportCalcRules(file, tableName)),
  onHide: () => dispatch(onHideImportCalcRules()),
});

const mapPropsToFields = ({ importRulesForm }) => ({
  file: Form.createFormField({ value: importRulesForm ? importRulesForm.file : null }),
});

const onFieldsChange = (props, fields) => props.onChange(fields);

const FileMappingWizardRulesImportForm = ({
  t,
  form,
  isVisible,
  importRulesForm,
  onSubmit,
  onHide,
  tempTableName,
}) => {
  return (
    <EnhancedModal
      visible={isVisible}
      onCancel={() => onHide()}
      title={t("data.fileMapping.importCalc.title")}
      width={MODAL_WIDTH_SM}
      footer={
        <div>
            <Button onClick={() => onHide()}>
              {t("commons.buttons.close.title")}
            </Button>
            <Button
              disabled={importRulesForm ? importRulesForm.file === null : true}
              icon="upload"
              type="primary"
              onClick={() => onSubmit(importRulesForm.file, tempTableName)}
            >
              {t("data.csv.uploadButton.label")}
            </Button>
        </div>
      }
    >
      <Form className="advanced-form">
        <Row type="flex" style={{ marginBottom: MARGIN_MD }} gutter={GUTTER_MD}>
          <Col span={SPAN_FULL}>
            <Form.Item
              className="form-item-required"
              label={t("data.csv.file.label")}
              style={{ marginRight: MARGIN_SM }}
            >
              {form.getFieldDecorator("file")(<FileInput accept={`.xml`} />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </EnhancedModal>
  );
};

export default compose(
  translate(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  Form.create({ mapPropsToFields, onFieldsChange })
)(FileMappingWizardRulesImportForm);
